import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'mmx-time-slot-picker-row',
  templateUrl: './time-slot-picker-row.component.html',
  styleUrls: ['./time-slot-picker-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TimeSlotPickerRowComponent { }
